import ProfilesView from "@features/profiles/view/profiles-view";

const Profiles = () => {
  return <ProfilesView />;
};

export default Profiles;
